import React from 'react';

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

import { muiThemeLuma } from 'themes';

interface IconFeatureSettingsProps extends SvgIconProps {
  fill?: string;
}

const IconFeatureSettings: React.FC<IconFeatureSettingsProps> = ({ fill, ...other }) => (
  <SvgIcon {...other}>
    <path
      d="M0 16H20V12H0V16ZM2 13H4V15H2V13ZM0 0V4H20V0H0ZM4 3H2V1H4V3ZM0 10H20V6H0V10ZM2 7H4V9H2V7Z"
      fill={fill || muiThemeLuma.palette.primary.main}
    />
  </SvgIcon>
);

export default IconFeatureSettings;
